import ToggleButton from "@components/miscellany/toggle_button/toggle_button"
import store from '../../../../edit/store'
import('./visibility_component.css')

export default function VisibilityComponent(opts){
    BaseConstructor.call(this)
    let container = opts.container
    let elements = {}
    let context = this
    let toggleButton
    let current_state

    this.generate = () =>{
        elements.container = this.createElement('div')
        elements.label = this.createElement('label', '', 'Visível')
        elements.button = this.createElement('div', '', '')

        $(elements.container).append(elements.label, elements.button)

        createToggleButton()

        $(container).html(elements.container)
    }

    this.update = () =>{

    }

    function createToggleButton(){
        current_state = store.getProgressBarOptionsNestedProp('options.show') || 'true'
        current_state = current_state === 'true'
        toggleButton = new ToggleButton({
            container: elements.button,
            custom_class: 'progress-bar-visibility-button',
            states:[
                {title: 'Sim', active:current_state, classList:'active'},
                {title: 'Não', active:!current_state}
            ]
        })
        toggleButton.generate()

        toggleButton.on('click', state =>{
            current_state = !current_state
            store.setProgressBarOptionsNestedProp('options.show', current_state)
        })
    }
}

VisibilityComponent.prototype = Object.create(BaseConstructor.prototype)